import React, { Component } from 'react';
import './index.scss';

class Keyboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyboardFlag: false, // 数字字母键盘
      strArr: ''// 字母数字
    };
    // this.delText = this.delText.bind(this);
    this.closeKeyboard = this.closeKeyboard.bind(this);
    // this.showKeyboard = this.showKeyboard.bind(this);
    this.cardNm = React.createRef();
  }

    // 记录输入数字字母
    showKeyboard = (e) => {
      e.stopPropagation();
      if (e.target && e.target.matches('ul')) {
        return;
      }
      let str = this.state.strArr;
      const strRes = str += e.target.innerText;
      this.setState({
        strArr: strRes
      }, () => {
        this.props.onInputParkno(strRes);
        // this.cardNm.current.value = this.state.strArr;
      });
    }

    // 删除已输入值
    delText = (e) => {
      e.stopPropagation();
      // 删除掉本地缓存中的车位号
      if (localStorage.getItem('parkingno')) localStorage.setItem('parkingno', '');
      const newStr = this.state.strArr.substring(0, this.state.strArr.length - 1);
      this.setState({
        strArr: newStr
      }, () => {
        this.props.onInputParkno(newStr);
        // this.cardNm.current.value = this.state.strArr;
      });
    }

    // 完成按钮 关闭键盘
    closeKeyboard(e) {
      e.stopPropagation();
      this.props.onHideKeyboadr();
    }

    // 点击空白地方隐藏弹窗
    hideMenu = (e) => {
      console.log('关闭键盘');
      this.props.onHideKeyboadr();
    }

    componentDidMount() {
      // document.addEventListener('click', this.hideMenu);
    }

    // 卸载异步操作设置状态
    componentWillUnmount() {
      this.setState = (state, callback) => {

      };
    }

    render() {
      const { shwoKeyboard } = this.props;
      return (
        <div className="keyboard-mask" onClick={this.hideMenu} style={{ display: shwoKeyboard ? 'block' : 'none' }}>
          <div className="keyboard" onClick={(e) => { e.stopPropagation(); }}>
            <ul onClick={this.showKeyboard}>
              <li><span>1</span></li>
              <li><span>2</span></li>
              <li><span>3</span></li>
              <li><span>4</span></li>
              <li><span>5</span></li>
              <li><span>6</span></li>
              <li><span>7</span></li>
              <li><span>8</span></li>
              <li><span>9</span></li>
              <li><span>0</span></li>
              <li><span>Q</span></li>
              <li><span>W</span></li>
              <li><span>E</span></li>
              <li><span>R</span></li>
              <li><span>T</span></li>
              <li><span>Y</span></li>
              <li><span>U</span></li>
              <li><span>I</span></li>
              <li><span>O</span></li>
              <li><span>P</span></li>
              <li><span>A</span></li>
              <li><span>S</span></li>
              <li><span>D</span></li>
              <li><span>F</span></li>
              <li><span>G</span></li>
              <li><span>H</span></li>
              <li><span>J</span></li>
              <li><span>K</span></li>
              <li><span>L</span></li>
              <li><span className="delete" onClick={this.delText}>&lt;</span></li>
              <li style={{ marginLeft: '-0.3rem' }}><span>Z</span></li>
              <li><span>X</span></li>
              <li><span>C</span></li>
              <li><span>V</span></li>
              <li><span>B</span></li>
              <li><span>N</span></li>
              <li><span>M</span></li>
              <li><span className="complete" onClick={this.closeKeyboard}>完成</span></li>
            </ul>
          </div>
        </div>
      );
    }
}
export default Keyboard;
